import styled from 'styled-components';
import { TYPOGRAPHY, COLOR } from '../../../../../theme/constants';
import { Button, FlexContainer } from '@emarketer/componentlibrary';

export const TimeframeManagerContainer = styled.div`
  width: 600px;
  padding: 24px;
  box-sizing: border-box;

  @media (max-width: 1200px) {
    max-width: 80vw;
    min-width: 300px;
  }
`;

export const TimeframeManagerActions = styled(FlexContainer)``;

export const TimeframeManagerDates = styled(FlexContainer)`
  margin-bottom: 50px;
`;

export const TimeframeManagerButton = styled(Button)<{ active?: boolean; 'aria-label': string }>`
  ${TYPOGRAPHY.BOLD};
  border: 2px solid ${COLOR.BLUE};

  ${(props) =>
    props.active
      ? `
    cursor: pointer;
  `
      : `
    cursor: default;
    pointer-events: none;
    opacity: 0.2;
  `}

  ${(p) =>
    p['aria-label'] === 'Cancel'
      ? `
    border: 2px solid ${COLOR.BLACK} !important;
    color: ${COLOR.BLACK} !important;
    background: ${COLOR.WHITE};

    &:hover {
      background: ${COLOR.WHITE};
      color: ${COLOR.BLACK} !important;
    }
  `
      : ''}
`;

export const TimeframeDateContainer = styled.div<{ disabledTimeframe: boolean }>`
  color: ${COLOR.BLACK};

  ${(props) =>
    props.disabledTimeframe
      ? `
    opacity: 0.4;
    cursor: default;
    span {
      color: grey;
    }
  `
      : ''}
`;

export const TimeframeDateButton = styled(Button)<{ disabledTimeframe: boolean }>`
  display: flex;
  align-items: center;
  font-size: 14px;
  ${TYPOGRAPHY.BOLD};
`;

export const TimeframeDateImage = styled.img`
  height: 20px;
  width: 20px;
  margin-right: 8px;
`;

export const TimeframeManagerNote = styled.div<{ active: boolean }>`
  color: ${COLOR.BLACK};
  font-size: 16px;
  ${TYPOGRAPHY.BOLD};
  margin-bottom: 20px;
  position: relative;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  ${(props) =>
    props.active
      ? `
    &:after {
      content: "*maximum reached";
      color: ${COLOR.RED};
      font-size: 13px;
      margin-left: 8px;
      animation: fadeIn 0.25s forwards;
    }
  `
      : ''}
`;
